function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.6362 7.90005L11.5 0L3.36375 7.90005C1.12125 10.0813 0 12.9896 0 15.7861C0 18.5826 1.12125 21.5329 3.36375 23.7141C5.60625 25.8954 8.55313 27 11.5 27C14.4469 27 17.3937 25.8954 19.6362 23.7141C21.8787 21.5329 23 18.5826 23 15.7861C23 12.9896 21.8787 10.0813 19.6362 7.90005ZM2.875 16.2895C2.88937 13.493 3.76625 11.7172 5.405 10.1372L11.5 4.08286L17.595 10.2071C19.2337 11.7732 20.1106 13.493 20.125 16.2895H2.875Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "currentColor"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/transparency.fb888c95.svg";
export { SvgComponent as ReactComponent };